<script setup lang="ts">

import TheBottomSheet from '@/components/TheBottomSheet.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import CoinIcon from '@/assets/images/icons/gold-coin-icon-s3.webp'
import { formatNumberFullTruncate } from '@/helpers/utils'
import CheckCirclePinkBorder from '@/components/icons/CheckCirclePinkBorder.vue'
import { useConfig } from '@/composables/game/config'
import { T } from '@tolgee/vue'

defineProps<{
  show: boolean
}>()
defineEmits(['hide'])

const { config } = useConfig()
</script>

<template>
  <TheBottomSheet
    :show="show"
    @hide="$emit('hide')"
  >
    <div class="w-full flex flex-col items-center">
      <CheckCirclePinkBorder
        wrapper-class="w-[120px] h-[120px] min-w-[120px]"
        icon-class="w-[64px]"
      />
      <div class="mt-6 text-2xl font-bold -tracking-[0.48px] text-light-white">
        <T
          key-name="daily_combo.completed"
          default-value="COMBO COMPLETE"
        />
      </div>
      <div class="mt-6 flex items-center gap-x-2">
        <img
          :src="CoinIcon"
          class="h-[32px] min-w-[32px]"
        >
        <span class="text-[24px] leading-10 -tracking-[0.5px] font-bold text-teal-primary">{{
          formatNumberFullTruncate(config.game.challenges.dailyCombo.reward)
        }}</span>
      </div>
      <BaseButton
        class="mt-8 w-full"
        @click="$emit('hide')"
      >
        <T
          key-name="daily_combo.claim"
          default-value="Claim prize"
        />
      </BaseButton>
    </div>
  </TheBottomSheet>
</template>

<style scoped>

</style>
